<script setup lang="ts">
  import PlusIcon from '@/shared/assets/icons/PlusIcon.svg';
  import { ColoredButton, FieldSearchBar } from '@/shared/ui';
  import { SEARCH_CRITERION_OPTIONS } from '../config/directoriesListing';
  import type { DirectorySearchCriterion } from '../model/directorySearch.utils';

  defineProps<{
    searchTerm: string;
    canCreateModule: boolean;
  }>();

  const searchCriterion = defineModel<DirectorySearchCriterion>('searchCriterion', {
    required: true,
  });

  const emit = defineEmits<{
    (event: 'create-module'): void;
    (event: 'search', term: string): void;
  }>();

  const handleSearchFieldChange = (value: string) => {
    searchCriterion.value = value as DirectorySearchCriterion;
  };
</script>

<template>
  <header
    data-testid="directories-page-header"
    class="shrink-0 pt-4 pb-4"
  >
    <h3 class="text-gray-07 text-xl/7.5 font-semibold text-left">
      Diretórios
    </h3>

    <ColoredButton
      v-if="canCreateModule"
      data-testid="btn-criar-modulo"
      class="mt-4"
      text="Criar Módulo"
      :icon="PlusIcon"
      icon-alt="Ícone de adição"
      @click="emit('create-module')"
    />

    <FieldSearchBar
      class="mt-4 w-full"
      :search-fields="SEARCH_CRITERION_OPTIONS"
      :search-field-id="searchCriterion"
      :initial-search-term="searchTerm"
      independent-search-field
      :clear-search-on-field-change="false"
      @search="emit('search', $event)"
      @update:search-field-id="handleSearchFieldChange"
    />
  </header>
</template>
